import { matchesSearch } from 'src/componentes/filtro/search-drawer/searchDrawerUtils';
import { Col, Row } from 'reactstrap';
import TipoPontoControleLookup from 'src/lookups/tipo-ponto-controle';
import { capitalizeFirstLetter } from 'src/utils/string';
import ResponsaveisLookup from 'src/lookups/colaborador';
import PeriodicidadeLookup from 'src/lookups/tipo-periodicidade-ponto-controle';
import InputNumber from 'src/componentes/input-number';
import TipoToleranciaLookup from 'src/lookups/tipo-tolerancia';
import TipoEvidenciaLookup from 'src/lookups/tipo-evidencia';
import FuncaoPontoControlelookup from 'src/lookups/funcao-pontocontrole';
import TipoDeControleLookup from 'src/lookups/tipo-de-controle';
import AreaLookup from 'src/lookups/item-organizacao';
import StatusControlSelfAssessmentLookup from 'src/lookups/StatusControlSelfAssessmentLookup';
import Input from 'src/componentes/input';
import Checkbox from 'src/componentes/checkbox';
import CollapsibleSection from 'src/componentes/CollapsibleSection';
import useAuth from 'src/hooks/useAuth';
import { ADDONS } from 'src/utils/constants';

const InformacoesBasicasSecao = ({
  model,
  resources,
  intl,
  configuracao,
  searchQuery,
}) => {
  const {addons} = useAuth();
  const possuiAddonCSA = addons?.find((x) => x.id === ADDONS.CONTROL_SELF_ASSESSMENT && x.ativo) != null;

  const fields = [
    { label: intl.formatMessage({ id: 'idIntegracao' }), id: 'idIntegracao' },
    { label: intl.formatMessage({ id: 'descricao' }), id: 'descricao' },
    { label: resources.responsaveis, id: 'responsaveis' },
    { label: resources.areas, id: 'areas' },
    {
      label: intl.formatMessage(
        { id: 'label.considerarAreasSubordinadas' },
        { areas: intl.formatMessage({ id: 'areas' }) }
      ),
      id: 'areasSubordinadas',
    },
    configuracao?.utilizarTipoPontoControle && {
      label: intl.formatMessage(
        { id: 'tipoPontoControle' },
        { pontodecontrole: resources.pontodecontrole }
      ),
      id: 'tipoPontoControle',
    },
    { label: intl.formatMessage({ id: 'periodicidade' }), id: 'periodicidade' },
    {
      label: intl.formatMessage({ id: 'tipoTolerancia' }),
      id: 'tipoTolerancia',
    },
    {
      label: intl.formatMessage({ id: 'diasToleranciaRevisao' }),
      id: 'diasToleranciaRevisao',
    },
    {
      label: intl.formatMessage({ id: 'numeroRevisoesGeradasAutomaticamente' }),
      id: 'numeroRevisoesGeradasAutomaticamente',
    },
    configuracao?.utilizarTipoEvidencia && {
      label: intl.formatMessage({ id: 'tipoEvidencias' }),
      id: 'tipoEvidencias',
    },
    configuracao?.funcaoPontoControle && {
      label: intl.formatMessage(
        { id: 'funcaoPontoControle' },
        { pontodecontrole: resources.pontodecontrole }
      ),
      id: 'funcaoPontoControle',
    },
    {
      label: intl.formatMessage(
        { id: 'tipoDeControle' },
        { pontodecontrole: resources.pontodecontrole }
      ),
      id: 'tipoDeControle',
    },
    possuiAddonCSA && configuracao?.temPermissaoVisualizarCSA && {
      label: intl.formatMessage({ id: 'statusControlSelfAssessment' }),
      id: 'statusControlSelfAssessment',
    },
  ].filter(Boolean);

  const matchCount = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  ).length;

  const visibleFields = fields.filter((field) =>
    matchesSearch(field.label, searchQuery)
  );

  if (!visibleFields.length && searchQuery) {
    return null;
  }

  return (
    <CollapsibleSection
      title={intl.formatMessage({ id: 'label.informacoesBasicas' })}
      startOpen={true}
      forceOpen={matchCount > 0 && searchQuery !== ''}
    >
      <Row>
        {visibleFields.includes(fields.find((f) => f.id === 'idIntegracao')) &&
          model?.getModel('idIntegracao') && (
            <Col md={12}>
              <Input model={model.getModel('idIntegracao')} />
            </Col>
          )}

        {visibleFields.includes(fields.find((f) => f.id === 'descricao')) &&
          model?.getModel('descricao') && (
            <Col md={12}>
              <Input model={model.getModel('descricao')} />
            </Col>
          )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'responsaveis')
        ) && (
          <Col md={12}>
            <ResponsaveisLookup
              multi
              model={{
                label: capitalizeFirstLetter(resources.responsaveis),
                value: model.getModel('responsaveis').value,
                requestChange: model.getModel('responsaveis').requestChange,
              }}
            />
          </Col>
        )}

        {visibleFields.includes(fields.find((f) => f.id === 'areas')) && (
          <Col md={12}>
            <AreaLookup
              multi
              clearable
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage(
                    { id: 'areas' },
                    { areas: resources.areas }
                  )
                ),
                value: model.getModel('areas').value,
                requestChange: model.getModel('areas').requestChange,
              }}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'areasSubordinadas')
        ) && (
          <Col md={12}>
            <Checkbox
              model={{
                label: intl.formatMessage(
                  { id: 'label.considerarAreasSubordinadas' },
                  { areas: resources.areas }
                ),
                value: model.getModel('areasSubordinadas').value,
                requestChange:
                  model.getModel('areasSubordinadas').requestChange,
              }}
              className="mb-3"
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'tipoPontoControle')
        ) && configuracao?.utilizarTipoPontoControle && (
          <Col md={12}>
            <TipoPontoControleLookup
              clearable
              model={{
                label: capitalizeFirstLetter(
                  intl.formatMessage(
                    { id: 'tipoPontoControle' },
                    { pontodecontrole: resources.pontodecontrole }
                  )
                ),
                value: model.getModel('tipoPontoControle').value,
                requestChange:
                  model.getModel('tipoPontoControle').requestChange,
              }}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'periodicidade')
        ) && (
          <Col md={12}>
            <PeriodicidadeLookup
              clearable
              model={model.getModel('periodicidade')}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'tipoTolerancia')
        ) && (
          <Col md={12}>
            <TipoToleranciaLookup clearable model={model.getModel('tipoTolerancia')} />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'diasToleranciaRevisao')
        ) && (
          <Col md={12}>
            <InputNumber model={model.getModel('diasToleranciaRevisao')} />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'numeroRevisoesGeradasAutomaticamente')
        ) && (
          <Col md={12}>
            <InputNumber
              model={model.getModel('numeroRevisoesGeradasAutomaticamente')}
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'tipoEvidencias')
        ) &&
          configuracao?.utilizarTipoEvidencia && (
            <Col md={12}>
              <TipoEvidenciaLookup
                clearable
                multi={true}
                model={model.getModel('tipoEvidencias')}
              />
            </Col>
          )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'funcaoPontoControle')
        ) &&
          configuracao?.funcaoPontoControle && (
            <Col md={12}>
              <FuncaoPontoControlelookup
                model={{
                  label: intl.formatMessage(
                    { id: 'funcaoPontoControle' },
                    { pontodecontrole: resources.pontodecontrole }
                  ),
                  value: model.getModel('funcaoPontoControle').value,
                  requestChange: model.getModel('funcaoPontoControle')
                    .requestChange,
                }}
                clearable
              />
            </Col>
          )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'tipoDeControle')
        ) && (
          <Col md={12}>
            <TipoDeControleLookup
              model={{
                label: intl.formatMessage(
                  { id: 'tipoDeControle' },
                  { pontodecontrole: resources.pontodecontrole }
                ),
                value: model.getModel('tipoDeControle').value,
                requestChange: model.getModel('tipoDeControle').requestChange,
              }}
              clearable
            />
          </Col>
        )}

        {visibleFields.includes(
          fields.find((f) => f.id === 'statusControlSelfAssessment')
        ) && possuiAddonCSA && configuracao?.temPermissaoVisualizarCSA && (
          <Col md={12}>
            <StatusControlSelfAssessmentLookup
              multi
              model={model.getModel('statusControlSelfAssessment')}
            />
          </Col>
        )}
      </Row>
    </CollapsibleSection>
  );
};
export default InformacoesBasicasSecao;
